import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuItem, MessageService } from "primeng/api";
import { Sharedservice } from "./../../shared-components/shared.service";
import { MasterHelpModel } from "../../models/MasterHelp.model";
import { MasterHelpService } from "../../services/masterhelp.service";
import { EngagementService } from "../../services/engagement.service";
import { UserService } from "../../services/user.service";
import { UserModel } from "../../models/user.model";
import { OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { debounce } from "rxjs/operators";
import { InfraService } from "src/app/services/infra.service";
import { HelpvideosService } from "src/app/services/helpvideos.service";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { LanguageConstants } from "../../shared-components/constant";
import { EngagementModel } from "../../models/engagement.model";
import { AuditingService } from "../../services/auditing.service";

@Component({
  selector: "app-stepwizard",
  templateUrl: "./stepwizard.component.html",
  styleUrls: ["./stepwizard.component.css"],
})
export class StepwizardComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  engagementId = +this.route.snapshot.paramMap.get("id");
  stepid = +localStorage.getItem("activeindex");
  display: boolean;
  flatfileUploaded: number;

  private loggedInUserId: number;
  private uploadRouteLink = `/engagement/${this.engagementId}/uploadsource`;
  private previewRouteLink = `/engagement/${this.engagementId}/previewsourcefile`;
  private userInputRouteLink = `/engagement/${this.engagementId}/inputcapture`;
  private assessmentRouteLink = `/engagement/${this.engagementId}/scenario`;
  private accountMappingRoutLink = `/engagement/${this.engagementId}/mappingselection`;
  private verificationRouteLink = `/engagement/${this.engagementId}/remediation`;
  private dataCheckRouteLink = `/engagement/${this.engagementId}/performdatacheck`;
  private schedulesRouteLink = `/engagement/${this.engagementId}/schedules`;
  private uploadDownloadFlatFileRouteLink = `/engagement/${this.engagementId}/uploaddownloadflatfile`;
  private plugAndPlayLink = `/engagement/${this.engagementId}/layout`;
  videoPopUpModel: boolean;
  videoPopUpModelSmall: boolean;
  stepClass: string;
  private activeIndex: number;
  private selectedRegionId: number;
  //IsPnP: boolean;
  private Templateid: number;
  step1HelpText: string;
  step1HelpTextTemplate: string;
  step2HelpText: string;
  step3HelpText: string;
  step4HelpText: string;
  step5HelpText: string;
  step6HelpText: string;
  step7HelpText: string;
  step8HelpText: string;
  langCode: string;
  currLangTranslation: any;
  private videoService: HelpvideosService;
  private videoList: any;
  private videoSrc: string;
  private uploadSrc: string;
  private previewAttributeSrc: string;
  private userInputsSrc: string;
  private assessmentSrc: string;
  private accountmappingsSrc: string;
  private verificationSrc: string;
  private datacheckSrc: string;
  private schedulesSrc: string;
  private uploadDownloadSrc: string;
  private videoUrl: string;
  IsLanguageChange: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private infraService: InfraService,
    public sharedService: Sharedservice,
    private masterHelpService: MasterHelpService,
    private router: Router,
    private engagementService: EngagementService,
    private messageService: MessageService,
    private userService: UserService,
    private translateService: TranslateService,
    private helpVideoService: HelpvideosService,
    private auditingService: AuditingService
  ) {
    this.infraService.infraDetails$.subscribe((data) => {
      this.selectedRegionId = data.InfraId;
      this.flatfileUploaded = this.sharedService.getLocalStorageValueByName(
        "isTempFlatfileUploaded" + this.engagementId + this.selectedRegionId
      );
      this.videoService = helpVideoService;
    });
  }

  items: MenuItem[];

  helpMenu: MasterHelpModel = new MasterHelpModel();
  public getmasterHelp(): void {
    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
        this.activeIndex =
          this.sharedService.getLocalStorageValueByName("activeindex");
        if (
          localStorage.getItem(
            "generateDatabookViaTemplate" +
              this.engagementId +
              this.selectedRegionId
          ) === "1"
        ) {
          if (
            this.engagementService.engModel.IsPnP &&
            this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId === 1
          ) {
            switch (this.activeIndex) {
              case 0:
                this.activeIndex = 0;
                break;
              case 1:
                this.activeIndex = 1;
                break;
              case 2: // Account mappings
                this.activeIndex = 4;
                break;
              case 3:
                this.activeIndex = 5; // Verification
                break;
              case 4:
                this.activeIndex = 6; // Data Check
                break;
              case 5:
                this.activeIndex = 7; // Schedules
                break;
              default:
                break;
            }
          } else {
            switch (this.activeIndex) {
              case 0:
                this.activeIndex = 0;
                break;
              case 1: // Account mappings
                this.activeIndex = 4;
                break;
              case 2:
                this.activeIndex = 5; // Verification
                break;
              case 3:
                this.activeIndex = 6; // Data Check
                break;
              case 4:
                this.activeIndex = 7; // Schedules
                break;
              default:
                break;
            }
          }
        }
        this.masterHelpService
          .getMasterHelp(this.activeIndex)
          .subscribe((data: MasterHelpModel) => {
            this.helpMenu = data;

            switch (this.helpMenu.StepId) {
              case 0:
                // Upload
                this.helpMenu.PageName =
                  this.currLangTranslation.step1.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step1.helpVideo.helpContent;
                this.step1HelpText =
                  this.currLangTranslation.step1.helpVideo.pageName;
                break;
              case 1:
                // Preview & attributes
                this.helpMenu.PageName =
                  this.currLangTranslation.step2.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step2.helpVideo.helpContent;
                this.step2HelpText =
                  this.currLangTranslation.step2.helpVideo.pageName;
                break;
              case 2:
                // User inputs
                this.helpMenu.PageName =
                  this.currLangTranslation.step3.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step3.helpVideo.helpContent;
                this.step3HelpText =
                  this.currLangTranslation.step3.helpVideo.pageName;
                break;
              case 3:
                // Assessment
                this.helpMenu.PageName =
                  this.currLangTranslation.step4.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step4.helpVideo.helpContent;
                this.step4HelpText =
                  this.currLangTranslation.step4.helpVideo.pageName;
                break;
              case 4:
                // Account Mapping
                this.helpMenu.PageName =
                  this.currLangTranslation.step5.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step5.helpVideo.helpContent;
                this.step5HelpText =
                  this.currLangTranslation.step5.helpVideo.pageName;
                break;
              case 5:
                //Verification
                this.helpMenu.PageName =
                  this.currLangTranslation.step6.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step6.helpVideo.helpContent;
                this.step6HelpText =
                  this.currLangTranslation.step6.helpVideo.pageName;
                break;
              case 6:
                // Data check
                this.helpMenu.PageName =
                  this.currLangTranslation.step7.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step7.helpVideo.helpContent;
                this.step7HelpText =
                  this.currLangTranslation.step7.helpVideo.pageName;
                break;
              case 7:
                // Schedules
                this.helpMenu.PageName =
                  this.currLangTranslation.step8.helpVideo.pageName;
                this.helpMenu.HelpContent =
                  this.currLangTranslation.step8.helpVideo.helpContent;
                this.step8HelpText =
                  this.currLangTranslation.step8.helpVideo.pageName;
                break;
              default:
                break;
            }

            if (
              localStorage.getItem(
                "generateDatabookViaTemplate" +
                  this.engagementId +
                  this.selectedRegionId
              ) === "1"
            ) {
              let currentactiveindex: number;
              currentactiveindex = <number>(
                (<any>(
                  this.sharedService.getLocalStorageValueByName("activeindex")
                ))
              );
              if (
                this.engagementService.engModel.IsPnP == true &&
                this.engagementService.engModel.TemplateId != "3" && this.engagementService.engModel.AccCalendarId === 1
              ) {
                if (currentactiveindex === 0) {
                  this.helpMenu.DisplayContent = false;
                }
                if (currentactiveindex === 1) {
                  // Download & Upload Flat file
                  this.helpMenu.PageName =
                    this.currLangTranslation.step1.helpVideo.pageNameTemplate;
                  this.helpMenu.HelpContent = this.currLangTranslation.step1.helpVideo.helpContent;
                  this.step1HelpTextTemplate =
                    this.currLangTranslation.step1.helpVideo.pageNameTemplate;
                }
              } else {
                if (currentactiveindex === 0) {
                  // Download & Upload Flat file
                  this.helpMenu.PageName =
                    this.currLangTranslation.step1.helpVideo.pageNameTemplate;
                  this.helpMenu.HelpContent = this.currLangTranslation.step1.helpVideo.helpContent;
                  this.step1HelpTextTemplate =
                    this.currLangTranslation.step1.helpVideo.pageNameTemplate;
                }
              }
            }
          });
      }
    });
  }

  private updateHelp(): void {
    this.masterHelpService
      .UpdatedHelp(this.activeIndex, this.helpMenu.DisplayContent)
      .subscribe((updatedData) => {});
  }

  hideDialog() {
    this.helpMenu.DisplayContent = false;
    this.updateHelp();
  }

  UpdateStepId() {
    this.engagementService
      .updateEngagementStepId(this.engagementId, this.stepid)
      .subscribe((response: any) => {});
  }

  SetRouterLink() {
    let currentactiveindex: number;

    currentactiveindex = <number>(
      (<any>this.sharedService.getLocalStorageValueByName("activeindex"))
    );

    if (currentactiveindex === 0) {
      this.previewRouteLink = null;
      this.userInputRouteLink = null;
      this.assessmentRouteLink = null;
      this.accountMappingRoutLink = null;
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.plugAndPlayLink = null;
    } else if (currentactiveindex === 1) {
      this.userInputRouteLink = null;
      this.assessmentRouteLink = null;
      this.accountMappingRoutLink = null;
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.plugAndPlayLink = null;
    } else if (currentactiveindex === 2) {
      this.assessmentRouteLink = null;
      this.accountMappingRoutLink = null;
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.plugAndPlayLink = null;
    } else if (currentactiveindex === 3) {
      this.accountMappingRoutLink = null;
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.plugAndPlayLink = null;
    } else if (currentactiveindex === 4) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.plugAndPlayLink = null;
    } else if (currentactiveindex === 5) {
      if (this.flatfileUploaded === 1) {
        this.uploadRouteLink = null;
        this.previewRouteLink = null;
        this.userInputRouteLink = null;
        this.assessmentRouteLink = null;
        this.accountMappingRoutLink = null;
        this.plugAndPlayLink = null;
        // this.verificationRouteLink = true;
      }

      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
    } else if (currentactiveindex === 6) {
      if (this.flatfileUploaded === 1) {
        this.uploadRouteLink = null;
        this.previewRouteLink = null;
        this.userInputRouteLink = null;
        this.assessmentRouteLink = null;
        this.accountMappingRoutLink = null;
        this.plugAndPlayLink = null;
      }

      this.schedulesRouteLink = null;
    } else if (currentactiveindex === 7) {
      if (this.flatfileUploaded === 1) {
        this.uploadRouteLink = null;
        this.previewRouteLink = null;
        this.userInputRouteLink = null;
        this.assessmentRouteLink = null;
        this.accountMappingRoutLink = null;
        this.plugAndPlayLink = null;
      }
      this.schedulesRouteLink = null;
      // } else if (currentactiveindex === 8) {
      //   if (this.flatfileUploaded === 1) {
      //     this.uploadRouteLink = null;
      //     this.previewRouteLink = null;
      //     this.userInputRouteLink = null;
      //     this.assessmentRouteLink = null;
      //     this.accountMappingRoutLink = null;
      //   }
    }
  }

  SetRouterLink1() {
    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data: EngagementModel) => {
        this.Templateid = data.TemplateId;
        //this.IsPnP = data.IsPnP;
        this.engagementService.engModel = data;
      });

      if (
        this.engagementService.engModel.IsPnP === true &&
        this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId === 1
      )
        this.SetPlugandPlaylink();
      else this.SetOldFlowlink();
  }

  SetOldFlowlink() {
    let currentactiveindex: number;
    currentactiveindex = <number>(
      (<any>this.sharedService.getLocalStorageValueByName("activeindex"))
    );
    if (currentactiveindex === 0) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.accountMappingRoutLink = null;
    } else if (currentactiveindex === 1) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
    } else if (currentactiveindex === 2) {
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
    } else if (currentactiveindex === 3) {
      this.schedulesRouteLink = null;
    }
  }

  SetPlugandPlaylink() {
    let currentactiveindex: number;
    currentactiveindex = <number>(
      (<any>this.sharedService.getLocalStorageValueByName("activeindex"))
    );
    if (currentactiveindex === 0) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.accountMappingRoutLink = null;
      this.uploadDownloadFlatFileRouteLink = null;
    } else if (currentactiveindex === 1) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
      this.accountMappingRoutLink = null;
    } else if (currentactiveindex === 2) {
      this.verificationRouteLink = null;
      this.dataCheckRouteLink = null;
      this.schedulesRouteLink = null;
    } else if (currentactiveindex === 3) {
      this.schedulesRouteLink = null;
      this.dataCheckRouteLink = null;
    } else if (currentactiveindex === 4) {
      this.schedulesRouteLink = null;
    }
  }
  getItemsForWizard2() {
    // this.engagementService
    //   .getEngagement(this.engagementId)
    //   .subscribe((data: EngagementModel) => {
    //     this.IsPnP = data.IsPnP;
    //   });

    if (
      this.engagementService.engModel.IsPnP === true &&
      this.engagementService.engModel.TemplateId != 3 && this.engagementService.engModel.AccCalendarId === 1
    ) {
      this.items = [
        {
          label: this.currLangTranslation.plugAndPlay.LayoutConfiguration,
          command: (event: any) => {
            localStorage.setItem("activeindex", "0");
          },
          routerLink: this.plugAndPlayLink, // 5
        },
        {
          label: this.currLangTranslation.step1.titleTemplate,
          command: (event: any) => {
            localStorage.setItem("activeindex", "1");
          },
          routerLink: this.uploadDownloadFlatFileRouteLink,
        },
        {
          label: this.currLangTranslation.step5.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "2");
          },
          routerLink: this.accountMappingRoutLink, // 4
        },
        {
          label: this.currLangTranslation.step6.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "3");
          },
          routerLink: this.verificationRouteLink, // 5
        },
        {
          label: this.currLangTranslation.step7.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "4");
          },
          routerLink: this.dataCheckRouteLink, // 6
        },
        {
          label: this.currLangTranslation.step8.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "5");
          },
          routerLink: this.schedulesRouteLink, // 7
        },
        // {
        //   label: "Plug And Play", command: (event: any) => { localStorage.setItem('activeindex', '8'); }, routerLink: this.plugAndPlayLink   // 8
        // }
      ];
    } else {
      this.items = [
        {
          label: this.currLangTranslation.step1.titleTemplate,
          command: (event: any) => {
            localStorage.setItem("activeindex", "0");
          },
          routerLink: this.uploadDownloadFlatFileRouteLink,
        },
        {
          label: this.currLangTranslation.step5.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "1");
          },
          routerLink: this.accountMappingRoutLink, // 4
        },
        {
          label: this.currLangTranslation.step6.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "2");
          },
          routerLink: this.verificationRouteLink, // 5
        },
        {
          label: this.currLangTranslation.step7.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "3");
          },
          routerLink: this.dataCheckRouteLink, // 6
        },
        {
          label: this.currLangTranslation.step8.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "4");
          },
          routerLink: this.schedulesRouteLink, // 7
        },
        // {
        //   label: "Plug And Play", command: (event: any) => { localStorage.setItem('activeindex', '8'); }, routerLink: this.plugAndPlayLink   // 8
        // }
      ];
    }
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    //this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.stepid = +localStorage.getItem("activeindex");
    this.sharedService.activeEngagementName =
      localStorage.getItem("activeEngName");
    this.sharedService.activePaceId = localStorage.getItem("activePaceId");
    this.getmasterHelp();
    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data: EngagementModel) => {
        let prevStepId = data.StepId;
        if (prevStepId > this.stepid) {
          const prevIndex = prevStepId + 1;
          const currActiveIndex = this.stepid + 1;
          const auditText = "Step" + prevIndex + " --> Step" + currActiveIndex;
          this.auditingService
            .addAudit(this.engagementId, auditText)
            .subscribe();
        }
        if (
          localStorage.getItem(
            "isTempFlatfileUploaded" + this.engagementId + this.selectedRegionId
          ) !== "1" &&
          localStorage.getItem(
            "generateDatabookViaTemplate" +
              this.engagementId +
              this.selectedRegionId
          ) === "1"
        ) {
          // skip the update step id
        } else {
          this.UpdateStepId();
        }
        this.engagementService.engModel = data;
      });

    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data) => {
        if (data.Status) {
          this.generateDatabookViaTemplate(data.RedirectToVerification);
          this.setStepComplete();
        } else {
          this.router.navigate(["unauthorize"], {
            queryParams: { redirectFrom: "closedproject" },
          });
        }
      });

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.getAllVideos();
        this.engagementService
          .getEngagement(this.engagementId)
          .subscribe((data) => {
            if (data.Status) {
              this.generateDatabookViaTemplate(data.RedirectToVerification);
              this.setStepComplete();
            } else {
              this.router.navigate(["unauthorize"], {
                queryParams: { redirectFrom: "closedproject" },
              });
            }
          });
      }
    );
    this.getAllVideos();
  }

  getAllVideos() {
    this.IsLanguageChange = true;
    this.videoService.getAllVideos().subscribe((res: any) => {
      this.videoList = res;
      this.videoList.forEach((element) => {
        switch (element.item1) {
          case "step1-upload": {
            this.uploadSrc = element.item2;
            break;
          }
          case "step2-preview-attributes": {
            this.previewAttributeSrc = element.item2;
            break;
          }
          case "step3-user-inputs": {
            this.userInputsSrc = element.item2;
            break;
          }
          case "step4-assesment": {
            this.assessmentSrc = element.item2;
            break;
          }
          case "step5-account-mappings": {
            this.accountmappingsSrc = element.item2;
            break;
          }

          case "step6-verification": {
            this.verificationSrc = element.item2;
            break;
          }
          case "step7-data-check": {
            this.datacheckSrc = element.item2;
            break;
          }
          case "step8-schedules": {
            this.schedulesSrc = element.item2;
            break;
          }
          // case "intro": {
          //   //statements;
          //   break;
          // }

          case "upload-download-flat-file": {
            this.uploadDownloadSrc = element.item2;
            break;
          }

          default: {
            this.videoUrl = "https://localhost:5200/nomatchfound";
            break;
          }
        }
      });
      this.IsLanguageChange = false;
    });
  }
  generateDatabookViaTemplate(redirectToVerificationflag: number) {
    if (
      localStorage.getItem(
        "generateDatabookViaTemplate" +
          this.engagementId +
          this.selectedRegionId
      ) === "1"
    ) {
      this.stepClass = "step-five";
      let currentactiveindex: number;
      currentactiveindex = <number>(
        (<any>this.sharedService.getLocalStorageValueByName("activeindex"))
      );

      this.SetRouterLink1();
      if (redirectToVerificationflag) {
        this.accountMappingRoutLink = null;
      }
      this.getItemsForWizard2();
    } else {
      this.stepClass = "step-eight";
      this.SetRouterLink();
      this.items = [
        {
          label: this.currLangTranslation.step1.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "0");
          },
          routerLink: this.uploadRouteLink,
        },
        {
          label: this.currLangTranslation.step2.title,
          command: (event: any) => {},
          routerLink: this.previewRouteLink,
        },
        {
          label: this.currLangTranslation.step3.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "2");
          },
          routerLink: this.userInputRouteLink,
        },
        {
          label: this.currLangTranslation.step4.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "3");
          },
          routerLink: this.assessmentRouteLink,
        },
        {
          label: this.currLangTranslation.step5.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "4");
          },
          routerLink: this.accountMappingRoutLink,
        },
        {
          label: this.currLangTranslation.step6.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "5");
          },
          routerLink: this.verificationRouteLink,
        },
        {
          label: this.currLangTranslation.step7.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "6");
          },
          routerLink: this.dataCheckRouteLink,
        },
        {
          label: this.currLangTranslation.step8.title,
          command: (event: any) => {
            localStorage.setItem("activeindex", "7");
          },
          routerLink: this.schedulesRouteLink,
        },
        // {
        //   label: "Plug And Play", command: (event: any) => { localStorage.setItem('activeindex', '8'); }, routerLink: this.plugAndPlayLink// 7
        // }
      ];
    }
  }

  ngOnDestroy() {
    // <== added this
    this.subscription.unsubscribe();
  }

  showVideo() {
    this.helpMenu.DisplayContent = false;
    this.videoPopUpModelSmall = false;
    this.videoPopUpModel = true;
  }

  showVideoMinimize() {
    this.videoPopUpModelSmall = true;
    this.videoPopUpModel = false;
  }

  showVideoMaximize() {
    this.videoPopUpModelSmall = false;
    this.videoPopUpModel = true;
  }

  hideVideoMinimize() {
    this.videoPopUpModelSmall = false;
  }

  private setStepComplete() {
    this.items.forEach((item) => {
      const index = this.items.indexOf(item);
      if (index < this.stepid) {
        item.styleClass = "steps-complete";
      } else if (index > this.stepid) {
        item.disabled = true;
      }
    });
  }
}
